import React, {useState, useRef, useEffect} from 'react';
import './styles.css';
import ReactDom from "react-dom";
import { Encriptar } from "@renedelangel/helpers";
import PopUpAlert from "../PopUpAlerta";
import { urlServidor } from "helpers";
import { isUsername,getIsUsernameID } from 'Querys/Login/metodos';
import LoaderLogoSoftwone from '_layout/assets/svg/Animaciones/logoSoftwone';



export default function PopUpRecuperarPassword(props){
    let {loginPrincipal, loginInside} = props;
    loginInside(false);
    const [openRecuperarPassword, setOpenRecuperarPassword] = useState(false);
    const [correoRecuperarPassword, setCorreoRecuperarPassword] = useState({
        correo: ''
    })
    const [loading, setLoading] = useState(false);

    const seedToken = "c29mdHdvbmVAc2VndW1leA==";

    const [textoAlert, setTextoAlert] = useState({
        titulo: "",
        mensaje: ""
    });

    const [openAlert, setOpenAlert] = useState(false);

    const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

    const regexpCorreo = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;

    function handleValidaciones({correo}){
        let error;
        let validaciones = [
            {
                condicion: correo == null || correo == "",
                ref: correoRef,
                keyError: "correo",
                mensajeError: "Debe indicar un correo"
            },
            {
                condicion: !regexpCorreo.test(correo),
                ref: correoRef,
                keyError: "correo",
                mensajeError: "Debe indicar un correo valido"
            },
        ];

        validaciones.forEach(({condicion, ref, mensajeError}) => {
            if(error) return;
            if(condicion){
                setTextoAlert({
                    titulo: "Revisa tus datos",
                    mensaje: mensajeError
                });
                setOpenAlert(true);

                ref.current.focus();
                ref.current.select();
                error = true;
            }
        });

        if(error) return error;
    }

    async function stop() {
        setCorreoRecuperarPassword({
            correo: ''
        })
        await delay(3000);
        setOpenAlert(false);
    }


    function handleChange(e){
        const {name, value} = e.target;
        setCorreoRecuperarPassword(prevState =>{ return{
            ...prevState,
            [name]: value
        }})
    }

    function handleClosePopUpRecuperarPassword(){
        setOpenRecuperarPassword(false);
        loginPrincipal(false);
        loginInside(false);}

    const {correo} = correoRecuperarPassword;

    

    const correoRef = useRef(null);


    async function recoverPass(datos) {

        

        const tokenTemp = Encriptar.GenerarToken({
            data: { usuario: {usuario: "temporal", usuarioID: datos.usuarioID} },
            expiresIn: "5m",
            seed: seedToken
        });

        let datosCompletos = [datos];
        let myHeaders = new Headers();
        myHeaders.append("token", tokenTemp);
        myHeaders.append("mimeType", "multipart/form-data");

        let formdata = new FormData();
        formdata.append("datos", JSON.stringify(datosCompletos));

        let requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: formdata
        };

        await fetch(
            `${urlServidor}/service/email/recoverPass`,
            requestOptions
        )
            .then(response => {
                if (!response.ok) return response.json();
                setLoading(false);
                setTextoAlert({
                    titulo: "Envio exitoso",
                    mensaje: "Se ha enviado tu solicitud para recuperar la contraseña de tu cuenta"
                });
                setOpenAlert(true);
                stop();
            })
            .catch(error => {
                setLoading(false);
                console.error("Error:", error);
            });
    }


    function ftRecoverPass(){
        async function ftRecoverPass(){
            setLoading(true);
            let {
                correo
            } = correoRecuperarPassword;

            let error = handleValidaciones({correo})

            if (error) {
                setLoading(false);
                return error;
            }

            let tokenTemp = Encriptar.GenerarToken({
                data: { usuario: "temporal" },
                expiresIn: "1m",
                seed: seedToken
            });

            try{
            let datos = await getIsUsernameID({filtro: {correo}}, tokenTemp);
           
            await recoverPass(datos);
            }catch({message}){
                setLoading(false);
                setTextoAlert({
                    titulo: "Error",
                    mensaje: message
                });
                setOpenAlert(true);
            }
            
        }
        ftRecoverPass();
    }

    return ReactDom.createPortal(<>
    <div className='contenedorGeneralPopUpRecuperarPassword' onClick={()=>{handleClosePopUpRecuperarPassword()}}>
        <div className='contenedorInternoPopUpRecuperarPassword' onClick={(e) =>{e.stopPropagation()}}>

            <div className='tituloPopUpRecuperarPassword'>
                RECUPERA TU CONTRASEÑA
            </div>
            <div className='descripcionPopUpRecuperarPassword'>
                    Te enviaremos un enlace a tu correo para que puedas cambiar la contraseña.
                </div>
                <input ref={correoRef} className='inputCorreoPopUpRecuperarPassword' placeholder='Email' type='input' name='correo' value={correo} onChange={(e) => handleChange(e)}>
                </input>
                <button onClick={() =>{ftRecoverPass()}}className='buttonEnviarPopUpRecuperarPassword'>
                    Enviar
                </button>
                <button onClick={() =>{handleClosePopUpRecuperarPassword()}}className='buttonRegresarPopUpRecuperarPassword'>
                    Regresar
                </button>
        </div>
    </div>

    {openAlert ? (
                <PopUpAlert
                    titulo={textoAlert.titulo}
                    mensaje={textoAlert.mensaje}
                    open={setOpenAlert}
                />
            ) : (
                <></>
            )}

            {
                loading ? 
                <LoaderLogoSoftwone/> :
                <></>
            }
    </>, document.getElementById('login'));
}